import { Router } from '@angular/router';

export abstract class QueryParamRetreiverUtils {
  static getQueryParamFromRouter(param: string, router: Router): string {
    return router.getCurrentNavigation()?.initialUrl.queryParams[param] ?? router.parseUrl(router.url).queryParams[param];
  }
}
